import request from '@/utils/request'

let StudymenuApi = {

  /*页面目录列表*/
  list(data) {
    return request._post('/shop/plus.studymenu.Index/index', data);
},
change(data) {
    return request._post('/shop/plus.studymenu.Index/charge', data);
},
/*添加页面目录*/
add(data) {
    return request._post('/shop/plus.studymenu.Index/add', data);
},
/*修改页面目录*/
edit(data) {
    return request._post('/shop/plus.studymenu.Index/edit', data);
},
/*删除页面目录*/
del(data) {
    return request._post('/shop/plus.studymenu.Index/del', data);
},
/*页面目录详情*/
detail(data) {
  return request._post('/shop/plus.studymenu.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.studymenu.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.studymenu.Setting/getSetting', data, errorback);
    },
}
export default StudymenuApi;



// WEBPACK FOOTER //
// ./src/api/studymenu.js